<template>
  <div class="landing-page otp-page">
    <div class="login-content">
      <div class="login login-send">
        <button class="back-button" type="button" @click="back">
          <img src="../../static/images/back.png" alt="Back">
        </button>
        <div class="logo-wrap"><img src="../../static/images/logo.png" alt="Bottle Pop"></div>
        <div class="middle"><img src="../../static/images/login_pic1.png" alt="Bottle Pop"></div>

        <div class="otp-form">
          <div class="otp-field">
            <div class="otp-label">{{ $t('phoneNumber') }}</div>
            <div class="otp-control otp-control--readonly">
              <input class="input" v-model="mobile" disabled aria-label="Phone number">
            </div>
          </div>

          <div class="otp-field">
            <div class="otp-label">OTP</div>
            <div class="otp-code-row">
              <div class="otp-control">
                <input class="input" v-model="otp" ref="getFocus2" maxlength="6" type="tel"
                       inputmode="numeric" pattern="[0-9]*" @input="handleOtpInput" aria-label="OTP">
              </div>
              <button class="otp-send-button" :class="{disable: codeText !== $t('getCode')}" type="button"
                      :disabled="codeText !== $t('getCode')" @click="getSendOtp">{{ codeText }}</button>
            </div>
          </div>

          <div class="otp-login-list">
            <button class="otp-login-button" type="button" @click="goLogin">
              <span class="day-en"><span class="btn-text">{{ $t('Login') }}</span></span>
            </button>
          </div>
        </div>

        <div class="otp-footer">
          <div class="footer-link" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
          <div class="footer-link" @click="getChange('faq')">{{ $t('FAQ') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      otp: '',
      codeText: '',
      isReturn: false,
      timer: null
    }
  },
  watch: {
    otp(now, old) {
      this.$nextTick(function () {
        if (now.length === 4 || old === now) {
          this.timer = setTimeout(() => {
            if (this.$refs.getFocus2) this.$refs.getFocus2.blur()
          }, 100)
        }
      })
    }
  },
  created() {
    this.codeText = this.$t('getCode')
    let login_mobile = sessionStorage.getItem('login_mobile') || '';
    if (login_mobile) {
      this.mobile = this.dealPhone_2(login_mobile)
      this.getSendOtp()
    }
    if (this.$route.query.msidn) {
      this.mobile = this.dealPhone_2(this.$route.query.msidn)
      this.getSendOtp()
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    handleOtpInput(event) {
      this.otp = event.target.value.replace(/[^0-9]/g, '')
    },
    getSendOtp() {
      const that = this
      if (that.isReturn) return
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      that.isReturn = true
      const mobile = that.dealPhone(that.mobile)
      that.$parent.loadModal(true)
      that.$secureApi.post('/api/user/login_send_otp', {mobile: mobile}, r => {
        that.isReturn = false
        that.$parent.loadModal(false)
        that.$utils.alertText(r.msg, 80, 3000)
        if (r.code == 1) that.countDown(61, 1)
      })
    },
    goLogin() {
      const that = this
      if (that.mobile === '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return
      }
      if (that.otp === '') {
        that.$utils.alertText(that.$t('otpTips'), 60)
        return
      }
      const mobile = that.dealPhone( that.mobile)
      const data = {
        mobile: mobile,
        otp: that.otp,
        device_id: that.getDeviceId()
      }
      that.$parent.loadModal(true)
      that.$secureApi.post('/api/user/login_verify_otp', data, r => {
        that.$parent.loadModal(false)
        if (r.code == 1) {
          let token = r.data.userinfo.token;
          let mobile = r.data.userinfo.mobile;
          localStorage.setItem('token', token);
          localStorage.setItem('mobile', mobile);
          window.location.href = '/app';
        } else {
          that.$utils.alertText(r.msg, 80)
        }
      })
    },
    countDown(seconds, type) {
      if (seconds === 1) {
        this.codeText = this.$t('getCode')
        return
      }
      seconds--
      if (type === 1) {
        this.codeText = seconds + 's'
        this.isReturn = false
      }
      this.timer = setTimeout(() => this.countDown(seconds, type), 1000)
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id')
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
        localStorage.setItem('device_id', id)
      }
      return id
    },
    getChange(type) {
      this.$router.push({path: '/' + type})
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('97') && phone.length === 10) phone = phone.substring(1)
      return phone
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, '')
      if (phone.startsWith('0909') && phone.length === 13) phone = phone.substring(3)
      if (phone.startsWith('09') && phone.length === 11) phone = phone.substring(1)
      if (phone.startsWith('099') && phone.length === 12) phone = phone.substring(2)
      return phone
    },
  }
}
</script>

<style scoped>
.otp-page {
  min-height: 100vh;
  background: url(../../static/images/land-bg.png) no-repeat center top;
  background-size: cover !important;
}

.back-button {
  position: absolute;
  top: clamp(14px, 3.2vw, 24px);
  left: clamp(14px, 3.2vw, 24px);
  width: clamp(44px, 8vw, 60px);
  height: clamp(44px, 8vw, 60px);
  padding: 8px;
  border: 0;
  z-index: 4;
  cursor: pointer;
}

.back-button img {
  width: 100%;
  display: block;
}

.logo-wrap {
  width: 100%;
  text-align: center;
}

.logo-wrap img {
  width: 35%;
  margin-top: 50px;
}

.middle img {
  top: clamp(118px, 28vw, 210px) !important;
}

.otp-form {
  margin: clamp(18px, 3vw, 24px) 40px 0;
  position: relative;
  z-index: 3;
}

.otp-field {
  width: 86%;
  margin-right: auto;
  margin-left: auto;
}

.otp-field + .otp-field {
  margin-top: clamp(14px, 3.2vw, 24px);
}

.otp-label {
  color: #fff;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 700;
  margin: 0 0 clamp(6px, 1.6vw, 12px);
  text-align: left;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.otp-control {
  width: 100%;
  height: clamp(56px, 12vw, 90px);
  min-width: 0;
  padding: 0 clamp(12px, 2.7vw, 20px) 0 clamp(5px, 1.1vw, 8px);
  display: flex;
  align-items: center;
  overflow: hidden;
  background: rgba(15, 52, 31, 0.82);
  border: 0;
  border-radius: 999px;
  box-shadow: inset 0 0 0 3px rgba(164, 255, 217, 0.18);
}

.otp-control--readonly {
  background: rgba(15, 52, 31, 0.82);
}

.phone-prefix {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-right: clamp(8px, 1.9vw, 14px);
}

.phone-prefix img {
  width: clamp(66px, 12.7vw, 95px);
  height: auto;
  display: block;
}

.otp-control .input {
  flex: 1;
  min-width: 0;
  height: auto;
  line-height: 1.2;
  margin: 0;
  padding: 0 clamp(14px, 3.2vw, 24px);
  color: #fff;
  font-weight: 700;
  background: transparent;
  opacity: 1;
  -webkit-text-fill-color: #fff;
  font-size: clamp(30px, 6.4vw, 46px) !important;
}

.otp-code-row {
  display: flex;
  align-items: stretch;
  gap: clamp(8px, 1.6vw, 12px);
}

.otp-code-row .otp-control {
  flex: 1;
}

.otp-send-button {
  flex: 0 0 clamp(104px, 25vw, 188px);
  padding: 0 clamp(8px, 1.6vw, 12px);
  background: #1948ba;
  border: 2px solid #fff;
  border-radius: 999px;
  color: #fff;
  font-family: Atom-sans;
  font-size: clamp(14px, 3.5vw, 26px);
  font-weight: 700;
  text-shadow: 0 1px 1px #0b1e62;
}

.otp-send-button:disabled {
  background: #6f83b6;
  color: rgba(255, 255, 255, 0.82);
}

.otp-login-list {
  width: 100%;
  margin-top: clamp(26px, 6vw, 46px);
  display: flex;
  justify-content: center;
}

.otp-login-button {
  width: calc((86% - clamp(10px, 2.4vw, 18px)) / 2);
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.otp-login-button .day-en {
  width: 100%;
  aspect-ratio: 309 / 162;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(../../static/images/daily-bg_en.png) no-repeat center;
  background-size: 100% 100%;
}

.otp-login-button .btn-text {
  font-size: clamp(20px, 4vw, 30px);
}

.otp-footer {
  width: 70%;
  max-width: 520px;
  margin: clamp(24px, 5vw, 40px) auto 0;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 3;
}

.footer-link {
  color: #8b4c12;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 900;
  white-space: nowrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue